import { ProState } from '../pro/ProState';
import { IAsyncSmartStorageProvider, StorageProvider } from '../support/StorageProvider';
import { Logger } from '../support/debug/Logger';
import { OperatorFlagsState } from '../profile/OperatorFlagsState';
import { State } from '@meraki-internal/state';
import { TrackingService } from '../support/tracking/TrackingService';

export class PreMissionWeatherFeatureAnnouncement extends State<Record<string, never>> {
    static inject = () => [
        ProState,
        StorageProvider,
        Logger,
        OperatorFlagsState,
        TrackingService
    ];
    constructor(
        private proState: ProState,
        storage: StorageProvider,
        private logger: Logger,
        private flags: OperatorFlagsState,
        private tracking: TrackingService
    ) {
        super({});
        this.storage = storage.getAsyncBooleanProvider('PreMissionWeatherFeatureAnnouncement.seen', { storageType: 'localStorage' });
    }

    close = () => {
        this.isOpen = false;
        this.setState({});
    };
    isOpen = false;

    getImagePath = () => {
        if (this.flags.hasFlag('weather-price-399')){
            return `./assets/images/paywall/weather-annoucement-no-wind.svg`;
        }
        return './assets/images/paywall/weather-announcement.svg';
    };

    private storage: IAsyncSmartStorageProvider<boolean>;

    private flagsThatShowAnnoucement = ['weather-feature-announcement', 'weather-price-399'];
    maybeShowFeatureAnnoucement = () => {
        Promise.resolve()
            .then(async () => {
                if (this.proState.hasPro()) {
                    return;
                }

                // if they don't have the flag, then no announcement
                if (!this.flagsThatShowAnnoucement.some(f => this.flags.hasFlag(f))){
                    return;
                }

                // if already seen it, no announcement
                if (await this.storage.get()){
                    return;
                }


                await this.storage.set(true);

                let announcementVersion = 1;
                if (this.flags.hasFlag('weather-price-399')){
                    announcementVersion = 2;
                }

                this.tracking.track('Weather Announcement Opened (Experiment)', () => ({
                    announcementVersion
                }));

                this.isOpen = true;
                this.setState({ });
            })
            .catch(err => {
                this.logger.error(`PreMissionWeatherFeatureAnnouncement.maybeShowFeatureAnnoucement failed gracefully, with error ${err.toString()}`);
            });
    };
}
